import Header from './Header';

export const availableRowSpacingOptions = ['compact-view', 'comfort-view'];

export default Header;
